import { makeSceneDoc } from '../kit.js';

/**
 * 邻家院子： livelihoods 城郊的人情第一课。
 * 老刘头坐在这儿，一条大狗拴着；好好说话能讨水喝，翻他家筐就需要看你的脸面。
 */
export const neighborYardDoc = makeSceneDoc({
  id: 'neighbor_yard',
  name: '邻家院子',
  region: 'suburb',
  tier: 0,
  node: 'neighbor_yard',
  desc: '篱笆上爬着豆角，一只黄狗懒洋洋地抬了抬眼皮。',
  w: 32, h: 22,
  fill: ',',
  spawn: { gx: 24, gy: 12 },
  draw(b, rng) {
    b.rect(0, 0, 32, 22, ',');
    b.rect(2, 2, 18, 10, ':');                     // 院子空地
    b.rect(24, 2, 6, 12, 'f');                     // 屋前菜畦
    // 篱笆
    for (let x = 1; x < 31; x += 1) b.set(x, 13, '#');
    for (let y = 2; y < 13; y += 2) b.set(1, y, '#');
    // 屋子
    b.rect(20, 2, 10, 6, '.');
    b.frame(20, 2, 10, 6, '#');
    b.set(24, 7, '+');
    // 一条通向外部的小径
    b.rect(28, 13, 3, 9, 'r');
    b.scatter(',', 18, { rng, area: [2, 2, 18, 10] });
  },
  props: [
    { type: 'overgrown_trellis', gx: 6, gy: 4 },
    { type: 'water_well', gx: 12, gy: 8 },
    { type: 'clothesline', gx: 16, gy: 3 },
    { type: 'clothesline', gx: 17, gy: 3 },
    { type: 'drying_rack', gx: 9, gy: 11 },
    { type: 'laundry_basin', gx: 8, gy: 9 },
    { type: 'old_liu', gx: 14, gy: 6 },
    { type: 'big_brown_dog', gx: 18, gy: 9 },
    { type: 'hay_pile', gx: 4, gy: 11 },
    { type: 'lot_bucket', gx: 6, gy: 8 },
    // 老刘头那间草房：画出来才知道这是有人住的地方
    { type: 'place_home', gx: 21, gy: 3, state: { name: '邻家' } },
  ],
  portals: [
    { to: 'country_road', gx: 29, gy: 21, spawn: [2, 13], label: '回土路' },
  ],
});

export default neighborYardDoc;
